export default data => {
  return Object.entries(data)
    .reduce((acc, [key, value]) => {
      if (!!value) {
        return [...acc, `${key}=${value}`];
      }
      return acc;
    }, [])
    .join('&');
};
